import { useEffect } from 'react';
import { useSentry } from './context';
import type { CFTPipeValue, CFTValue } from './sentry-tags';

/**
 * @deprecated Use `useSentrySetOwner` from `./use-sentry-set-owner` instead.
 * CFTs have been replaced by teams.
 */
export function useSentrySetCft({ cft, pipe }: { cft: CFTValue; pipe?: CFTPipeValue }): void {
  const sentry = useSentry();

  // Setting the tag must happen inside the effect, not the render body: React 18 StrictMode
  // double-invokes mount effects (mount -> cleanup -> mount) right after the initial commit,
  // and a render-body-only set (guarded by a "mounted" ref) never re-runs after that, so the
  // tag would be stuck on the cleanup's 'no-cft' value for the rest of the component's life.
  useEffect(() => {
    sentry.setTagInCurrentScope('CFT', cft);
    sentry.setTagInCurrentScope('PIPE', pipe);

    return () => {
      sentry.setTagInCurrentScope('CFT', 'no-cft');
      sentry.setTagInCurrentScope('PIPE', undefined);
    };
  }, [cft, pipe, sentry]);
}
